import {
  VolleyballCardsAttribute,
  VolleyballIncidentId,
} from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const YellowCardPopup = new PopupBuilder('YellowCard', {
  incident_id: VolleyballIncidentId.Cards,
  attribute_ids: [VolleyballCardsAttribute.YellowCard],
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
